module.exports = __webpack_public_path__ + "img/icon_process_04.e20ef7f0.svg";